import React from 'react';
import ResultsList from './ResultsList';

const AvailableBuildings = ({ results, highlightedBuilding, setSelectedBuilding, loadMoreData }) => {
  return (
    <div className="available-buildings">
      <h3>Available Buildings</h3>
      <ResultsList
        results={results}
        highlightedBuilding={highlightedBuilding}
        setSelectedBuilding={setSelectedBuilding}
        loadMoreData={loadMoreData}
      />
    </div>
  );
};

export default AvailableBuildings;
